/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  notfound: {
    id: "b2b.zakaznik-detail.notfound",
    defaultMessage: "Customer with CIN: {ico} not found."
  }
});

export default () => useMessages(MESSAGES);
